<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">作业车辆调度申请</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <car-control ref="create" :userData="userData" :formByFather="form"></car-control>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
              <div class="tip" style="line-height:26px">
                <p>1. 出县车辆须经部门负责人审核;<br />
                  2. 跨地区作业车辆调度车辆须经分管副总审批;<br />
                  3. 跨公司作业车辆调度/出省车辆须经集团公司分管副总审批。</p>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitCar()" class="form-btn" type="success">确认提交作业车辆调度申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import CarControl from '@/page/form/car/control'
  export default {
    components: {
      ApprovalItem,
      CarControl,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          depId: "",

          carType: "",
          useTime: "",
          time: "",
          startTime: "",
          endTime: "",
          xmName: "",
          driverId: "",

          applyType: "",
          json: true,
        },
        // useApplyType: "",
        // carType: "",
        approvalUsersData: '',
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.calcApplyType()
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/car/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.depId = this.form.department.id
          if (this.form.startTime && this.form.endTime) {
            this.form.time = [this.form.startTime, this.form.endTime]
          }

          this.form.applyId = this.form.flow.applyId

          this.form.json = true

          this.form.applyType = this.form.type

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, this.applyInfo.type)
          this.formLoading = false
        })
      },
      // 提交作业车辆调度申请单
      SubmitCar() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()
        if (!this.form.carId) {
          this.$message.error('请选择车辆，如无对应车辆信息，请联系相关同事添加')
          return
        }
        // 作业车辆调度时间
        if (this.form.time) {
          this.form.startTime = this.form.time[0]
          this.form.endTime = this.form.time[1]
        } else {
          this.$message.error("车辆作业车辆调度时间不能为空")
          return
        }

        this.formLoading = true
        let _url = !this.form.applyId ? '/car/apply' : '/car/apply/edit?applyId=' + this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交作业车辆调度申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改作业车辆调度申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Car/ControlList')
        }, (res) => {
          this.formLoading = false
        })
      },
      // 识别审批type
      calcApplyType() {
        this.form.applyType = '86'
        this.approvalUsersData = this.approvalUsers['c' + this.form.applyType]
        this.setSelectArr(this.applyInfo, this.form.applyType)
      },
    },
    watch: {
      // 'carType'() {
      //   this.calcApplyType()
      // },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/car/controlApply.vue